<template>
  <div class="page-inner">
    <header class="page-title-bar">
      <div class="d-md-flex align-items-md-start">
        <h1 class="page-title mr-sm-auto">
          Resultados de búsqueda
        </h1>
        <div class="btn-toolbar">
          <div class="dropdown">
            <a class="btn btn-outline-primary"
               href="/dashboard">
              <i class="fas fa-home"></i>
              <span class="ml-1">Inicio</span>
            </a>
          </div>
        </div>
      </div>
    </header>
    <div class="page-section">
      <protocols ref="protocolsList"
                 :paginationData="paginationData"
                 :protocols="protocols"
                 @update-table-data="updateProtocolsData"></protocols>
    </div>
  </div>
</template>

<script>
  import Protocols from '../components/search/Protocols'
  import { mapActions } from 'vuex'
  
  export default {
    name: 'Search',
    components: {
      Protocols,
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        vm.loadProtocols(to.query)
      })
    },
    async beforeRouteUpdate (to, from, next) {
      this.loadProtocols(to.query)
      
      next()
    },
    data () {
      return {
        search: 'test',
        protocols: [],
        paginationData: {},
      }
    },
    methods: {
      ...mapActions({
        getProtocols: 'protocols/getProtocols',
      }),
      
      async loadProtocols (query) {
        if (query.s) {
          this.$refs.protocolsList.loading = true
          
          const response = await this.getProtocols({
            q: query.s,
          })
          
          if (response.status === 'error') {
            AlertManager.error(response.error)
          }
          else {
            const {
                    data,
                    links,
                    meta,
                  } = response
            
            this.protocols      = data
            this.paginationData = {
              links,
              meta,
            }
          }
          
          this.$refs.protocolsList.loading = false
        }
      },
      
      updateProtocolsData (data, paginationData) {
        this.protocols      = data
        this.paginationData = paginationData
      },
    },
    computed: {},
    mounted () {
      $('body').removeClass('has-sidebar-container')
    },
  }
</script>
